import React from "react";
import ReactDOM from 'react-dom';
import "../static/css/profile.css";
import "bootstrap-icons/font/bootstrap-icons.css";


export function Profile(props) {
  const profile = <div style={{width:"80%", margin:"0 auto"}}>
    <div className="card p-3">
        <div className="d-flex align-items-center">
            <div className="image"> <img src="https://bootdey.com/img/Content/avatar/avatar7.png"
             className="rounded" width="55%"/> </div>
            <div className="ml-3 w-100">
                <h4 className="mb-0 mt-0" style={{color:"blue"}}><b>Pawanpreet Mundi</b></h4> <span>Software Devloper, Tutor</span>
                <div>
                <h6 className="theme-color" style={{color:"black", backgroundColor:"rgba(0,0,255,0.05)"}}>4th year student at University of Toronto.
                Computer Science specialist and Math minor. 3.6 Cgpa. Teaching experience includes
                Teaching Assistant position for Computer Programming course at UofT.
                Math tutor at Math Project Tutoring center. Volunteer tutor at high school
                Math club.
                </h6>
                </div>
            </div>
            </div>

            <div className="row about-list">
            <div className="col-md-6">
            <div className="media">
            <label>Age</label>
            <p>21 Yr</p>
            </div>
            <div className="media">
            <label>Address</label>
            <p>48 Zanetta Cres. L6Y6A2 Brampton ON CA</p>
            </div>
            </div>
            <div className="col-md-6">
            <div className="media">
            <label>E-mail</label>
            <p>pawanpreetmundi@gmail.com</p>
            </div>
            <div className="media">
            <label>Phone</label>
            <p>647-913-9900</p>
            </div>
            <div className="media">
            <a href="https://www.linkedin.com/in/pawanpreet-mundi-072123225" target="_blank" rel="noopener noreferrer">LinkedIn</a><br/>

            </div>
            </div>

        </div>
    </div>
</div>;

  const profilee = <section className="section about-section gray-bg" id="about">
  <div className="container">
  <div className="row align-items-center flex-row-reverse">
  <div className="col-lg-6">
  <div className="about-text go-to">
  <div className="col-lg-6">
  <div className="about-avatar">
  <img id="avatar" src="https://bootdey.com/img/Content/avatar/avatar7.png" title="" alt=""/>
  </div>
  <h3 className="dark-color">Pawanpreet Mundi</h3>
  </div>
  <h6 className="theme-color" style={{color:"black"}}>4th year student at University of Toronto.
  Computer Science specialist and Math minor. Teaching experience includes
  Teaching Assistant position for Computer Programming course at UofT.
  Math tutor at Math Project Tutoring center. Volunteer tutor at high school
  Math club.
  </h6>
  <div className="row about-list">
  <div className="col-md-6">
  <div className="media">
  <label>Age</label>
  <p>21 Yr</p>
  </div>
  <div className="media">
  <label>Address</label>
  <p>48 Zanetta Cres. L6Y6A2 Brampton ON CA</p>
  </div>
  </div>
  <div className="col-md-6">
  <div className="media">
  <label>E-mail</label>
  <p>pawanpreetmundi@gmail.com</p>
  </div>
  <div className="media">
  <label>Phone</label>
  <p>647-913-9900</p>
  </div>
  <div className="media">
  <a href="https://www.linkedin.com/in/pawanpreet-mundi-072123225" target="_blank" rel="noopener noreferrer">LinkedIn</a><br/>

  </div>
  </div>
  </div>
  </div>
  </div>
  </div>
  </div>
  </section>

  return profile;
}
